import { render, staticRenderFns } from "./OfferingCard.vue?vue&type=template&id=07bc8d93&scoped=true"
import script from "./OfferingCard.vue?vue&type=script&lang=ts"
export * from "./OfferingCard.vue?vue&type=script&lang=ts"
import style0 from "./OfferingCard.vue?vue&type=style&index=0&id=07bc8d93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc8d93",
  null
  
)

export default component.exports